import { BaseModel } from './base.model';
import { Deserializable } from './deserializable';

export class RatingtypeModel extends BaseModel implements Deserializable {

  // columns
  name: any;
  legend: any;
  min_value: number; // tslint:disable-line: variable-name
  max_value: number; // tslint:disable-line: variable-name
  step: number;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }

}
